import { render } from "./talentNetwork.vue?vue&type=template&id=a031c34a&scoped=true"
import script from "./talentNetwork.vue?vue&type=script&lang=js"
export * from "./talentNetwork.vue?vue&type=script&lang=js"

import "./talentNetwork.vue?vue&type=style&index=0&id=a031c34a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a031c34a"]])

export default __exports__